import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgReportCarService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    selector: "report-car-temper-summary"
    ,templateUrl: './dtg.report.car.temper.summary.component.html'
    ,providers: []
})
export class DtgReportCarTemperSummaryComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    DtgListType = DtgListType;
    selectedDate:any;
    listSummary:any;
    userGroupId:number;
    dtgTeamId:string = "";

    @Input()
    set inputSelectedDate(selectedDate){
        this.selectedDate = selectedDate;
        if(selectedDate){
            this.reloadListSummary();
        }
    }

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListSummary(){
        // if(this.selectedDate){
        //     let searchDateFrom = this.selectedDate.searchDateFrom;
        //     let searchDateTo = this.selectedDate.searchDateTo;
        //     let searchInfo = {
        //         companyId:this.companyInfo?.companyId || 0
        //         ,dtgTeamId:this.currentUserInfo?.teamId || ""
        //         ,dtgEid:this.companyInfo?.dtgEid || ""
        //         ,searchDateFrom:searchDateFrom
        //         ,searchDateTo:searchDateTo
        //         ,dtgGroupByRegDtYy:"Y"
        //         ,dtgGroupByRegDtMm:"Y"
        //     };
        //     this.fvmsApiDtgReportCarService.getListReportCarSumAll(searchInfo)
        //         .pipe(takeWhile(() => this.isContinue))
        //         .subscribe(apiResponse => {
        //             if(apiResponse.resultStatus === "ok"){
        //                 if(apiResponse.resultValue){
        //                     // console.log("reloadListSummary",apiResponse.resultValue);
        //                     this.listSummary = apiResponse.resultValue;
        //                 }
        //             }
        //         });
        // }
    }

    //전체 운행대수
    getSumDriveCnt(){
        return this.listSummary?.dtgDriveCarCnt || 0;
    }

    //일평균 운행대수
    getAvgDriveCnt(){
        let sumCnt = this.getSumDriveCnt();
        let listCnt = this.listSummary?.diffDay || 1;
        return Math.round(sumCnt / listCnt);
    }

    //전체 운행거리
    getSumDist(){
        return this.listSummary?.dtgDistAccumul || 0;
    }

    //일평균 운행거리
    getAvgDist(){
        let sumCnt = this.getSumDist();
        let listCnt = this.listSummary?.diffDay || 1;
        return Math.round(sumCnt / listCnt);
    }

    //전체 운행시간
    getSumDuration(){
        return this.listSummary?.dtgRegDtDuration || 0;
    }

    //일평균 운행시간
    getAvgDuration(){
        let sumCnt = this.getSumDuration();
        let listCnt = this.listSummary?.diffDay || 1;
        return Math.round(sumCnt / listCnt);
    }

    //전체 연료소모량
    // getSumOilUse(){
    //     return this.listSummary?.dtgOilUseAccumul || 0;
    // }

    //일평균 연료소모량
    // getAvgOilUse(){
    //     let sumCnt = this.getSumOilUse();
    //     let listCnt = this.listSummary?.diffDay || 1;
    //     return Math.round(sumCnt / listCnt);
    // }

    getTemper1Min(){
        return this.listSummary?.dtgTemper1From || 0;
    }

    getTemper1Max(){
        return this.listSummary?.dtgTemper1To || 0;
    }

    getTemper2Min(){
        return this.listSummary?.dtgTemper2From || 0;
    }

    getTemper2Max(){
        return this.listSummary?.dtgTemper2To || 0;
    }
}